@if (form.errors?.['dateMismatch']) {
    <div class="error">
        Даты "От" и "До" должны совпадать.
    </div>
}

@if (form.errors?.['minHourDifference']) {
    <div class="error">
        Время "От" не может быть больше времени "До"
    </div>
}

@if (form.errors?.['invalidOrder']) {
    <div class="error">
        Даты "От" и "До" должны совпадать.
    </div>
}

@if (form.errors?.['pastTime']) {
    <div class="error">
        Время и дата выполнения заявки не может быть меньше текущего времени.
    </div>
}
